export const employmentTypes = [
    { value: 'full-time', label: 'Full Time' },
    { value: 'part-time', label: 'Part Time' },
    { value: 'contract', label: 'Contract' },
];

export const MASTER_FIELDS_MAPPING = {
    'Position Title': 'title',
    Role: 'role',
    'Hiring Manager': 'hiringManager',
    Location: 'location',
    'Employment Type': 'employmentType',
    Experience: 'experience',
    'Budget Range': 'budget',
    'Mandatory Skills': 'skills',
    'Job Description': 'description',
};
